import React from 'react';
// import VariationForm from './VariationForm_upgrade'; // Removed - uses old bookWorksheetUpgrade state
// ✅ PHASE 2: Use the upgrade form for enhanced functionality
import VariationForm from './VariationForm_upgrade';
// Removed context import - using props instead
import { variationValidationSchema } from '../common/ValidationSchemas';
// Note: VariationVersionsList_upgrade import was removed from this file

/**
 * Panel component that contains the variation form with audio support
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isEditing - Whether the form is in edit mode
 * @param {Object} props.formikRef - Reference to the Formik form
 * @param {Function} props.handleSubmit - Handler for form submission
 * @param {Object} props.selectedBook - The selected book
 * @param {Object} props.selectedCharacter - The selected character
 * @param {Object} props.selectedVariation - The selected variation
 * @param {string} props.signedAudioUrl - The signed URL for the audio file
 * @param {Object} props.activeParams - Active parameters for the audio player
 * @param {string} props.newVariationId - UUID for new variations
 * @param {Function} props.setIsEditing - Function to set editing state
 * @param {Function} props.onSampleDelete - Function to call when a sample is deleted
 * @param {Object} props.selectedSampleForNewVariation - Sample data to use as base for new variation
 * @param {boolean} props.isCreatingFromSample - Whether we're creating a new variation from a sample
 * @param {Function} props.onUseAsBase - Function to handle "Use as Base" action
 * @param {Function} props.onCancelCreateFromSample - Function to cancel creating from sample
 * @param {Function} props.setShowDeleteModal - Function to show delete modal
 * @returns {JSX.Element} VariationFormPanel component
 */
const VariationFormPanel = React.memo(({
  // Form props
  isEditing,
  formikRef,
  handleSubmit,
  // Entity props
  selectedBook,
  selectedCharacter,
  selectedVariation,
  // Audio props
  signedAudioUrl,
  activeParams,
  // Other props
  newVariationId,
  setIsEditing,
  onSampleDelete,
  setShowDeleteModal,
  // "Use as Base" functionality props
  selectedSampleForNewVariation,
  isCreatingFromSample,
  onUseAsBase,
  onCancelCreateFromSample
}) => {
  // Phase 3: setShowDeleteModal now comes from props instead of context

  // Memoize the form component to prevent unnecessary re-renders
  const formComponent = React.useMemo(() => {
    if (!selectedCharacter) return null;

    return (
      <>
        <VariationForm
          isEditing={isEditing}
          formikRef={formikRef}
          selectedVariation={selectedVariation}
          selectedCharacter={selectedCharacter}
          validationSchema={variationValidationSchema}
          handleSubmit={handleSubmit}
          signedAudioUrl={signedAudioUrl}
          activeParams={activeParams}
          setShowDeleteModal={setShowDeleteModal}
          selectedBook={selectedBook}
          newVariationId={newVariationId}
          setIsEditing={setIsEditing}
          onSampleDelete={onSampleDelete}
          selectedSampleForNewVariation={selectedSampleForNewVariation}
          isCreatingFromSample={isCreatingFromSample}
          onUseAsBase={onUseAsBase}
          onCancelCreateFromSample={onCancelCreateFromSample}
        />
      </>
    );
  }, [
    isEditing,
    formikRef,
    selectedVariation,
    selectedCharacter,
    handleSubmit,
    signedAudioUrl,
    activeParams,
    setShowDeleteModal,
    selectedBook,
    newVariationId,
    setIsEditing,
    onSampleDelete,
    selectedSampleForNewVariation,
    isCreatingFromSample,
    onUseAsBase,
    onCancelCreateFromSample
  ]);

  return (
    <div>
      {selectedCharacter && formComponent}
    </div>
  );
});

// Add display name for debugging
VariationFormPanel.displayName = 'VariationFormPanel';

export default VariationFormPanel;
